module.exports = __webpack_public_path__ + "static/media/google-play-badge@2x.668e26a6.jpg";